import axios from 'axios';
import { getAuthHeader } from '../auth';

const baseURL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8080/api'
    : '/api';

const client = axios.create({
  baseURL,
});

export const getArticles = (lang = 'RU') => {
  return client.get(`/articles?lang=${lang}`);
};

export const getArticle = (slug, lang = 'RU') => {
  return client.get(`/articles/${slug}?lang=${lang}`);
};

export const incrementArticleView = (slug) => {
  return client.post(`/articles/${slug}/view`);
};

export const getAdminArticles = (lang = 'RU') => {
  return client.get(`/articles/admin?lang=${lang}`, {
    headers: { ...getAuthHeader() },
  });
};

export const getAdminArticle = (id) => {
  return client.get(`/articles/admin/${id}`, {
    headers: { ...getAuthHeader() },
  });
};

export const createArticle = (payload) => {
  return client.post('/articles/admin', payload, {
    headers: { ...getAuthHeader() },
  });
};

export const updateArticle = (id, payload) => {
  return client.put(`/articles/admin/${id}`, payload, {
    headers: { ...getAuthHeader() },
  });
};

export const deleteArticle = (id) => {
  return client.delete(`/articles/admin/${id}`, {
    headers: { ...getAuthHeader() },
  });
};